import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _calculateTaxRequest = {};
var _calculateTaxResponse = {};
var _listTaxCalculatorsRequest = {};
var _listTaxCalculatorsResponse = {};
function resolveWixBillingV1TaxCalculationUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/billing/v1/calculate-tax',
                destPath: '/v1/calculate-tax',
            },
            {
                srcPath: '/billing/v1/list-tax-calculators',
                destPath: '/v1/list-tax-calculators',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/billing/v1/calculate-tax',
                destPath: '/v1/calculate-tax',
            },
            {
                srcPath: '/billing/v1/list-tax-calculators',
                destPath: '/v1/list-tax-calculators',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Calculates tax for the provided line items.
 *
 * Tax is calculated for each line item based on the [tax region](https://dev.wix.com/docs/rest/business-management/payments/tax/tax-regions)
 * that corresponds to the address provided in `lineItems.addressIndex` and the tax group in `taxGroupId`. If no tax region is found for
 * the line item's address then no tax will be calculated for this line item. If no tax group with that `taxGroupId` is found then the
 * [default tax group](https://dev.wix.com/docs/rest/business-management/payments/tax/tax-groups/list-default-tax-groups) is used to calculate tax.
 *
 * The tax is calculated by a tax calculator app installed on the site.
 * Use [List Tax Calculators](https://dev.wix.com/docs/rest/business-management/payments/tax/tax-calculation/list-tax-calculators)
 * to see which tax calculators are available. To provide your own tax calculations, use the [Tax Calculation Integration Service Plugin](https://dev.wix.com/docs/rest/business-management/payments/tax/tax-calculation-integration-spi).
 *
 * The breakdown of calculated tax returned, includes:
 * + `taxSummary`: The overall total tax calculated.
 * + `taxSummary.aggregatedTaxBreakdown`: The total tax calculated for each jurisdiction.
 * + `lineItemTaxDetails.taxSummary`: The total tax calculated for each line item.
 * + `lineItemTaxDetails.taxBreakdown`: The tax calculated for each line item in each jurisdiction.
 */
export function calculateTax(payload) {
    var _a = serializer(_calculateTaxRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_calculateTaxResponse, {}).fromJSON;
    function __calculateTax(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.gateways.billing.v1.tax_calculation_gateway',
            method: 'POST',
            methodFqn: 'wix.billing.v1.TaxCalculation.CalculateTax',
            url: resolveWixBillingV1TaxCalculationUrl({
                protoPath: '/v1/calculate-tax',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __calculateTax.fromReq = fromReq;
    __calculateTax.__isAmbassador = true;
    return __calculateTax;
}
/**
 * Retrieves a list of installed tax calculators.
 *
 * Wix uses these calculators to [calculate tax](https://dev.wix.com/docs/rest/business-management/payments/tax/tax-calculation/calculate-tax).
 */
export function listTaxCalculators(payload) {
    var _a = serializer(_listTaxCalculatorsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listTaxCalculatorsResponse, {}).fromJSON;
    function __listTaxCalculators(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.gateways.billing.v1.tax_calculation_gateway',
            method: 'GET',
            methodFqn: 'wix.billing.v1.TaxCalculation.ListTaxCalculators',
            url: resolveWixBillingV1TaxCalculationUrl({
                protoPath: '/v1/list-tax-calculators',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listTaxCalculators.fromReq = fromReq;
    __listTaxCalculators.__isAmbassador = true;
    return __listTaxCalculators;
}
//# sourceMappingURL=http.impl.js.map